import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import Row from 'react-bootstrap/Row';
import FormGroup from 'react-bootstrap/FormGroup';
import Col from 'react-bootstrap/Col';
import FormControl from 'react-bootstrap/FormControl';
import Container from 'react-bootstrap/Container';
import cx from 'classnames';

import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';

import { siteSettings } from '../../../actions/siteadmin/siteSettings';
import { updateFavIcon } from '../../../actions/siteadmin/updateFavIcon';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, logoUploadDir, faviconUploadDir, siteUrl, ogImageUploadDir } from '../../../config';
import onSubmit from './submit'
import validate from './validate'

import messages from '../../../locale/messages'

import s from './SiteSettingsForm.css';
import bt from '../../../components/commonStyle.css';
export class SiteSettingsForm extends Component {

  static defaultProps = { loading: false };

  successLogo = async (fileName) => {
    const { change, updateTempImages } = this.props;
    await change('homeLogo', fileName);
    await updateTempImages('SiteSettings', 'homeLogo', fileName);
  }

  successFavicon = async (fileName) => {
    const { change, updateTempImages, updateFavIcon } = this.props;
    await change('favicon', fileName);
    await updateFavIcon(fileName)
    await updateTempImages('SiteSettings', 'favicon', fileName);
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className, maxlength }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormGroup className={s.formGroup}>
          <div>
            <label className={bt.labelText} >{label}</label>
          </div>
          <div>
            <FormControl {...input} placeholder={label} type={type} className={bt.formControlInput} maxlength={maxlength} />
            {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
          </div>
        </FormGroup>
      </div>
    );
  };

  renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormGroup className={s.formGroup}>
          <div>
            <label className={bt.labelText} >{label}</label>
          </div>
          <div>
            <FormControl
              {...input}
              className={className}
              placeholder={label}
              as="textarea"
              rows="3"
            >
              {children}
            </FormControl>
            {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
          </div>
        </FormGroup>
      </div>
    );
  };

  renderFormControlCodeArea = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormGroup className={s.formGroup}>
          <div>
            <label className={bt.labelText} >{label}</label>
          </div>
          <div>
            <FormControl
              {...input}
              className={className}
              placeholder={label}
              as="textarea"
              rows="6"
              style={{ fontFamily: 'monospace', fontSize: '13px' }}
            >
              {children}
            </FormControl>
            {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
          </div>
        </FormGroup>
      </div>
    );
  };

  render() {
    const { handleSubmit, logo, loading, submitting, favicon, intl: { formatMessage }, logoImageLoader, faviconImageLoader } = this.props;
    const { ogImage, ogImageLoader } = this.props;
    return (
      <Container fluid>
        <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>{formatMessage(messages.siteSettings)}</div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row className='siteSettingDropzoneRow'>
            <Col xs={12} sm={12} md={12} lg={6} xl={4} className={cx(s.marbtm14)}>
              <div className={cx(s.profileImgSection, 'bgBlackTwo')}>
                <div className={cx('commonFilepicker')}>
                  <ImageUploadComponent
                    className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
                    subTextClass={cx(s.subText, 'textWhiteTwo')}
                    subText={formatMessage(messages.maximumUploadSizeLabel)}
                    defaultMessage={formatMessage(messages.chooseFile)}
                    loaderName={'logoImageLoader'}
                    postUrl={api.apiEndpoint + '/uploadLogoImage'}
                    handleDropzone={this.successLogo}
                    loader={logoImageLoader}
                    fieldName={'homeLogo'}
                    formName={'SiteSettingsForm'}
                    imageSrc={logo ? api.apiEndpoint + logoUploadDir + logo : null}
                    label={formatMessage(messages.logo)}
                    labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={4} className={cx(s.marbtm14)}>
              <div className={cx(s.profileImgSection, 'bgBlackTwo')}>
                <div className={'commonFilepicker'}>
                  <ImageUploadComponent
                    className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
                    subTextClass={cx(s.subText, 'textWhiteTwo')}
                    subText={formatMessage(messages.maximumUploadSizeLabel)}
                    defaultMessage={formatMessage(messages.chooseFile)}
                    postUrl={siteUrl + '/uploadFavicon'}
                    handleDropzone={this.successFavicon}
                    loaderName={'faviconImageLoader'}
                    loader={faviconImageLoader}
                    imageSrc={favicon ? siteUrl + faviconUploadDir + favicon : null}
                    fieldName={'favicon'}
                    formName={'SiteSettingsForm'}
                    label={formatMessage(messages.favIconlogoLabel)}
                    labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={4} className={cx(s.marbtm14)}>
              <div className={cx(s.profileImgSection, 'bgBlackTwo')}>
                <div className={'commonFilepicker'}>
                  <ImageUploadComponent
                    className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
                    subTextClass={cx(s.subText, 'textWhiteTwo')}
                    subText={formatMessage(messages.maximumUploadSizeLabel)}
                    defaultMessage={formatMessage(messages.chooseFile)}
                    loaderName={'ogImageLoader'}
                    postUrl={api.apiEndpoint + '/uploadOgImage'}
                    loader={ogImageLoader}
                    fieldName={'ogImage'}
                    formName={'SiteSettingsForm'}
                    imageSrc={ogImage ? api.apiEndpoint + ogImageUploadDir + ogImage : null}
                    label={formatMessage(messages.ogImageLabel)}
                    toolTip={formatMessage(messages.ogImageTooltip)}
                    labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
                    isBottom={true}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="siteName" type="text" component={this.renderFormControl} label={formatMessage(messages.siteName)} />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="siteTitle" type="text" component={this.renderFormControl} label={formatMessage(messages.siteTitle)} />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="metaKeyword" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.metakey)} />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="metaDescription" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.metaDesc)} />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="facebookLink" type="text" component={this.renderFormControl} label={'Facebook URL'} placeholder={formatMessage(messages.youtubeUrl)} />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="twitterLink" type="text" component={this.renderFormControl} label={'X URL'} placeholder={formatMessage(messages.youtubeUrl)} />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="instagramLink" type="text" component={this.renderFormControl} label={'Instagram URL'} placeholder={formatMessage(messages.youtubeUrl)} />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="youtubeLink" type="text" component={this.renderFormControl} label={'Youtube URL'} placeholder={formatMessage(messages.youtubeUrl)} />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h5 className={cx(s.headingMobile, 'headingMobileRTL')}>{formatMessage(messages.trackingCodeSettings)}</h5>
              <p className={cx(bt.labelText)}>{formatMessage(messages.trackingCodeSettingsDesc)}</p>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="headerCode" component={this.renderFormControlCodeArea} label={formatMessage(messages.headerCode)} />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className={cx(bt.space2)}>
              <Field name="bodyCode" component={this.renderFormControlCodeArea} label={formatMessage(messages.bodyCode)} />
            </Col>
          </Row>
          <div className={cx(bt.textAlignRight, 'textAlignLeftRTL', 'loadingBtnRTL')}>
            <FormGroup className={s.formGroup}>
              <div>
                <Loader
                  type={"button"}
                  label={formatMessage(messages.submitButton)}
                  show={loading}
                  buttonType={'submit'}
                  className={cx(bt.btnPrimary, bt.clickBtn)}
                  disabled={submitting || loading}
                  isSuffix={true}
                />
              </div>
            </FormGroup>
          </div>
        </form>
      </Container>
    )
  }
}

SiteSettingsForm = reduxForm({
  form: 'SiteSettingsForm',
  onSubmit,
  validate
})(SiteSettingsForm);

const selector = formValueSelector('SiteSettingsForm')

const mapState = (state) => ({
  logo: selector(state, 'homeLogo'),
  favicon: selector(state, 'favicon'),
  ogImage: selector(state, 'ogImage'),
  appForceUpdate: selector(state, 'appForceUpdate'),
  loading: state.loader.SiteSettings,
  logoImageLoader: state.loader.logoImageLoader,
  faviconImageLoader: state.loader.faviconImageLoader,
  ogImageLoader: state.loader.ogImageLoader
});

const mapDispatch = {
  siteSettings,
  change,
  updateTempImages,
  updateFavIcon
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(SiteSettingsForm)));